// ft = font
// bg = background
//dis_plc = display placement
let ft_family='"Roboto", sans-serif';
let font_size_12=12
let font_size_14=14
let font_color_black="#000000"
let font_color_white="#ffff"

export const commonsettings = {
       template:{
           temp_title:{
                    topHeaderLogoPosition: "center start",
                    topHeaderBarcodePosition: "center center",
                    topHeaderLogoRequired: true,
                    headerBarcodeRequired: false,
                    topHeaderPosition: "center end",
                    topHeaderRequired: true,
                    headerlogoName:"Tenant",
                    topHeaderheight: 60,
                    topHeaderlineheight: 18,
                    topheaderbgColor: font_color_white,
                    topheaderfontColor: "#333333",
                    topheaderfontfamily: ft_family,
                    pageTitle: null,
                    rowCount:"",
                    comma:'No',
                    pageTitleHeaderRequired: true,
                    pageTitlefontsize: 14,
                    topHeaderLines:[]
           },
           page_title:{                                      // page title settings
               column:    2,
               row:    5,                                     // 4 or 2
               ft_lbl_color:  "#474747",
               ft_lbl_size:   11,
               ft_value_color:  font_color_black,
               ft_value_size:   font_size_12,                                 // col:2 only ('left,center,right)
               fields:[]
           },
           footer:{
                FooterLogoPosition: "center start",
                FooterLogoRequired: false,
                FooterSignatureRequired:false,
                FooterQRRequired:false,
		FooterNotesRequired:false,
                Footersignature: false,
                 FootersignaturePosition:"center start",
                FooterNotes:"",
                FooterPosition: "center end",
                FooterNotesfontsize:12,
                FooterRequired: false,
                FooterbgColor: font_color_white,
                FooterfontColor: "#333333",
                Footerfontfamily: ft_family,
                Footerheight: 60,
                Footerlineheight: 18,
                bottomDocsignLabel: "",
                bottomDocsignLabelsize: 12,
                bottomDocsignPosition: "center end",
                bottomDocsignftcol: font_color_black,
                bottomDocsignimg: null,
                bottomDocsignrequired: null
           },
           bgColor:     font_color_white,
           bgimage:     null,
           imagewidth: 60,
           bgposition:  null,
           ps: 'A4',
           orientation: 'Portrait',
           tm:0,
           bm:0,
           lm:0,
           rm:0,
           bodylayout:'Top Bottom',
           labelColor:'#333333',
           fontColor:'#333333',
           fontSize: font_size_14,
           fontfamily: ft_family,
       },
       body:{                                               // details default settings
           header: {
              ft_color:   font_color_black,
              ft_family:  ft_family,
              ft_size:    font_size_12,
              mandatory: false,
              active:    true,
              dis_plc:   "left"
           },
           value: {
              ft_color:  font_color_black,
              ft_family: ft_family,
              ft_size:   font_size_12,
              mandatory: false,
              active:    true,
              dis_plc:   "left"
           },
       },
       font_style_lists:[
           {value:'"andale mono", monospace',text:'Andale Mono'},
           {value:'arial, helvetica, sans-serif',text:'Arial'},
           {value:'"arial black", sans-serif',text:'Arial Black'},
           {value:'"book antiqua", palatino, serif',text:'Book Antiqua'},
           {value:'"comic sans ms", sans-serif',text:'Comic Sans MS'},
           {value:'"courier new", courier, monospace',text:'Courier New'},
           {value:'georgia, palatino, serif',text:'Georgia'},
           {value:'helvetica, arial, sans-serif',text:'Helvetica'},
           {value:'impact, sans-serif',text:'Impact'},
           {value:'"Roboto", sans-serif',text:'Roboto'},
           {value:'symbol',text:'Symbol'},
           {value:'tahoma, arial, helvetica, sans-serif',text:'Tahoma'},
           {value:'terminal, monaco, monospace',text:'Terminal'},
           {value:'"times new roman", times, serif',text:'Times New Roman'},
           {value:'"trebuchet ms", geneva, sans-serif',text:'Trebuchet MS'},
           {value:'verdana, geneva, sans-serif',text:'Verdana'},
            {value:'Open sans, geneva, sans-serif',text:'Open sans'},
           {value:'"Tactic Sans Extended", sans-serif', text:'Tactic Sans Extended'},
       ],
       positions:["Left","Center","Right"],
       font_size:{
           floor: 0,
           ceil: 50
       },
       editorConfig:{
        width:'auto',
        height:'auto',
        plugins:
          'print preview fullpage searchreplace autolink \
          directionality visualblocks visualchars fullscreen \
          image imagetools  media  table template codesample preview \
          charmap hr pagebreak nonbreaking anchor insertdatetime \
          advlist lists textcolor wordcount contextmenu colorpicker textpattern autoresize link image code',
          toolbar:
          'fontselect bold italic forecolor fontsizeselect strikethrough backcolor \
           alignleft aligncenter alignright alignjustify table lineheight \
           numlist bullist outdent indent preview fullscreen code  ',
          image_advtab: true,
          imagetools_toolbar:
          'rotateleft rotateright | flipv fliph | editimage imageoptions',
          toolbar_location: 'bottom',
          statusbar : false,
          toolbar_mode: 'floating',
          menubar:false,
          content_security_policy: "default-src 'self'",
         font_formats: 'Tactic Sans Extended="Tactic Sans Extended",sans-serif;Roboto="Roboto",sans-serif;Arial=arial,helvetica,sans-serif;',
content_style: "@font-face{font-family:'Tactic Sans Extended';src:url('/assets/fonts/TacticSans-ExtBd.woff2') format('woff2');font-weight:bold;} table { width: 100% !important; }",

          table_default_styles: {
            width: '100%'
          },
          setup: function (editor) {
            editor.on('init', function () {
              editor.contentDocument.querySelectorAll('table').forEach((table) => {
                table.style.width = '100%';
              });
            });
        
            editor.on('change', function () {
              editor.contentDocument.querySelectorAll('table').forEach((table) => {
                table.style.width = '100%';
              });
            });
        
            editor.on('BeforeSetContent', function (e) {
              e.content = e.content.replace(/<table\b([^>]*)>/gi, function(match, attrs) {
                  // Check if style attribute already exists
                  if (/style\s*=\s*["'][^"']*["']/i.test(attrs)) {
                      // Append width: 100% to existing style
                      return match.replace(/style\s*=\s*["']([^"']*)["']/i, function(_, styleValue) {
                          // If width is already defined, skip adding
                          if (/width\s*:\s*[^;]+/i.test(styleValue)) {
                              return `style="${styleValue}"`;
                          }
                          return `style="${styleValue} width: 100%;"`;
                      });
                  } else {
                      // No style attribute, add it
                      return `<table${attrs} style="width: 100%;">`;
                  }
              });
          });
          },
          init_instance_callback: function(editor) {
            editor.on('ExecCommand', function(e) {
              if("LineHeight"==e.command){
              }
            });
          }
        // superscript subscript anchor
      },
      printCommonStyle:`
      p {
        margin-bottom: 8px !important;
      }
      .print-display-none{
        display: none !important;
      }
      table.report-container{
        page-break-after: always;
        width: 100%;
      }
      table.report-header{
        display: table-header-group;
      }
      table.report-footer{
        display: table-footer-group;
      }
      .no-padd-right{
        padding-right: 0px !important;
      }
      .comma-symbol{
        float: right;
        top: 0;
        right: 0;
        position: absolute;
        padding-right: 5px;
        padding-left: 5px;
      }
      .pl {
          padding-left: 25px !important;
       }
       .no-border{
          border-bottom:0px solid black !important
        }
      `,
      styleUrls:[{ rel: 'stylesheet', href: '/assets/css/print.css' },{ rel: 'stylesheet', href: '/assets/css/custom.css' },
      { rel: 'stylesheet', href: 'https://maxcdn.bootstrapcdn.com/bootstrap/4.4.1/css/bootstrap.min.css' }
    ],
      templateVariableLists:[
        {
          name:'Patient Details',
          data:[
            {fieldname:'{patientfname}',descreption:'To Display Patient Firstname'},
            {fieldname:'{patientlname}',descreption:'To Display Patient Lastname'},
            {fieldname:'{patientname}',descreption:'To Display Patient Firstname and Lastname'},
            {fieldname:'{patientid}',descreption:'To Display Patient Registration Number'},
            {fieldname:'{patientage}',descreption:'To Display Patient Age'},
            {fieldname:'{patientgender}',descreption:'To Display Patient Gender'},
            {fieldname:'{patientmno}',descreption:'To Display Patient Mobile Number'},
            {fieldname:'{patientguardian}',descreption:'To Display Patient Guardian Name'},
            {fieldname:'{patientstatus}',descreption:'To Display Patient Status'},
            {fieldname:'{patientreferral}',descreption:'To Display Patient Referral'},

            {fieldname:'{patientnhid}',descreption:'To Display Patient NHID'},
            {fieldname:'{patientaadharno}',descreption:'To Display Patient AADHAAR No'},
            {fieldname:'{patienttitle}',descreption:'To Display Patient Title'},
            {fieldname:'{patientregdate}',descreption:'To Display Patient Registration Date'},
            {fieldname:'{patientdob}',descreption:'To Display Patient Date of Birth'},
            {fieldname:'{patientemail}',descreption:'To Display Patient Email'},
            {fieldname:'{patientdoorno}',descreption:'To Display Patient Doorno'},
            {fieldname:'{patientaddres1}',descreption:'To Display Patient Address1'},
            {fieldname:'{patientaddres2}',descreption:'To Display Patient Address2'},
            {fieldname:'{patientcity}',descreption:'To Display City'},
            {fieldname:'{patientpincode}',descreption:'To Display Patient Pincode'},
            {fieldname:'{frroNo}',descreption:'To Display Patient FRRO Number'},
           ]
        },
        {
          name:'Doctor Details',
          data:[
            {fieldname:'{docname}',descreption:'To Display Doctor Name'},
            {fieldname:'{docdept}',descreption:'To Display Department Name'},
           ]
        },
        {
          name:'Appointment Details',
          data:[
            {fieldname:'{hospitalTokenNo}',descreption:'To Display Hospital Token Number'},
            {fieldname:'{departmentTokenNo}',descreption:'To Display Department Token Number'},
            {fieldname:'{doctorTokenNo}',descreption:'To Display Doctor Token Number'},
           ]
        },
        {
          name:'Admission Details',
          data:[
  {fieldname:'{patientipno}',descreption:'To Display Admission Number'},
            {fieldname:'{admdocname}',descreption:'To Display Admission Doctor Name'},
            {fieldname:'{admdocdept}',descreption:'To Display Admission Department Name'},
            {fieldname:'{admdoat}',descreption:'To Display Admission Date and Time'},
            {fieldname:'{admwardname}',descreption:'To Display Admission Ward Name'},
            {fieldname:'{admbedno}',descreption:'To Display Admission Bed No'},
            {fieldname:'{printedby}',descreption:'To Display Admission Slip Printed By'},
            {fieldname:'{createdby}',descreption:'To Display Admission Created By'},
            {fieldname:'{aadharno}',descreption:'To Display patient AADHAAR no'},
            {fieldname:'{dlnumber}',descreption:'To Display DL number'},
            {fieldname:'{abhanumber}',descreption:'To Display ABHA number'},
            {fieldname:'{occupation}',descreption:'To Display patient occupation'},
            {fieldname:'{mlcno}',descreption:'To Display MLC Number'},
            {fieldname:'{secondaryphysicianname}',descreption:'To Display Secondary Physician'},
            {fieldname:'{relationship}',descreption:'To Display Relationship'},
            {fieldname:'{relativename}',descreption:'To Display Relative Name'},
            {fieldname:'{relativenumber-1}',descreption:'To Display Relative Number-1'},
            {fieldname:'{relativenumber-2}',descreption:'To Display Relative Number-2'},
            {fieldname:'{wardname}',descreption:'To Display Current Ward Name'},
            {fieldname:'{bedno}',descreption:'To Display Current Bed No'},


           ]
        },
        {
          name:'Discharge Details',
          data:[
             {fieldname:'{disdodt}',descreption:'To Display Discharge Date and Time'},
             { fieldname: "{planneddiscdate}", descreption: "To Display Planned Discharge Date" },
             { fieldname: "{planneddisctime}", descreption: "To Display Planned Discharge Time" },
             {fieldname: "{surgeonName}", descreption: "To Display Surgeon Name"}
           ]
        },
        {
          name:'Vitals Details & OPD',
          data:[
            {fieldname:'{vitalheight}',descreption:'To Display Patient Height'},
            {fieldname:'{vitalpulse}',descreption:'To Display Patient Pulse'},
            {fieldname:'{vitalbp}',descreption:'To Display Patient BP'},
            {fieldname:'{vitalweight}',descreption:'To Display Patient Weight'},
            {fieldname:'{vitaltemparature}',descreption:'To Display Patient Temparatre'},
            {fieldname:'{vitalspo}',descreption:'To Display Patient SPO2'},
            {fieldname:'{vitalbmi}',descreption:'To Display Patient BMI'},
            {fieldname:'{vitalresp}',descreption:'To Display Patient Respiratory Rate'},
            {fieldname:'{patientaddress}',descreption:'To Display Patient Address1'},
           ]
        },
        {
          name:'Visit Details',
          data:[
            {fieldname:'{visitdate}',descreption:'To Display Patient Visit Date'},
            {fieldname:'{visittime}',descreption:'To Display Patient Visit Time'},
            {fieldname:'{appointmentno}',descreption:'To Display Patient Appointment No.'},
           ]
        },
        {
          name:'Sales Bill Details',
          data:[
            {fieldname:'{id}',descreption:'To Display Serial No'},
            {fieldname:'{medicinename}',descreption:'To Display Medicine Name'},
            {fieldname:'{medicineCategory}',descreption:'To Display Medicine Category'},
            {fieldname:'{Batch}',descreption:'To Display Medicine Batch'},
            {fieldname:'{ExpDate}',descreption:'To Display Medicine Expiry Date'},
            {fieldname:'{qty}',descreption:'To Display Medicine Quantity'},
            {fieldname:'{phSellRate}',descreption:'To Display Medicine Rate'},
            {fieldname:'{phSellAmount}',descreption:'To Display Medicine Amount (Quantity * Rate)'},
            {fieldname:'{phDiscAmt}',descreption:'To Display Medicine Discount'},
            {fieldname:'{gst}',descreption:'To Display Each Medicine GST %  '},
            {fieldname:'{phNetAmount}',descreption:'To Display Net Amount'},
            {fieldname:'{taxableAmount}',descreption:'To Display Taxable Amount'},
            {fieldname:'{gstpercentage}',descreption:'To Display GST %'},
            {fieldname:'{cgst}',descreption:'To Display CGST'},
            {fieldname:'{sgst}',descreption:'To Display SGST'},
            {fieldname:'{igst}',descreption:'To Display IGST'},
            {fieldname:'{taxtotal}',descreption:'To Display Tax Total Amount'},
            {fieldname:'{totallineitemsdiscount}',descreption:'To Display Line Discount Amount'},
            {fieldname:'{phBillTotal}',descreption:'To Display Details Total Amount'},
            {fieldname:'{phtaxTotal}',descreption:'To Display Overall Tax Total Amount'},
            {fieldname:'{phDiscountamount}',descreption:'To Display Final Discount Amount'},
            {fieldname:'{phRoundofftpe}',descreption:'To Display Round off Type'},
            {fieldname:'{phRoundoff}',descreption:'To Display Round off'},
            {fieldname:'{paymentType}',descreption:'To Display Payment Details'},
            {fieldname:'{phNettotal}',descreption:'To Display Sales Bill Net Amount'},

           ]
        },
        {
          name:'OP Prescription Details',
          data:[
            {fieldname:'{id}',descreption:'To Display serial no'},
            {fieldname:'{medicineName}',descreption:'To Display medicine name'},
            {fieldname:'{medicineCategoryName}',descreption:'To Display medicine category'},
            {fieldname:'{genericname}',descreption:'To Display medicine generic name'},
            {fieldname:'{mrngaftevngngt}',descreption:'To Display medicine when taken M/A/E/N'},
            {fieldname:'{takenAtenglish}',descreption:'To Display medicine taken option like BF,AF'},
            {fieldname:'{duration}',descreption:'To Display medicine duration'},
            {fieldname:'{durationUnit}',descreption:'To Display medicine duration unit'},
            {fieldname:'{qty}',descreption:'To Display medicine quantity'},
            {fieldname:'{drugIntakeRoute}',descreption:'To Display route option'},
            {fieldname:'{drugUsageArea}',descreption:'To Display apply area option'},
            {fieldname:'{instructionadviceheading}',descreption:'To Display instruction or advice heading'},
            {fieldname:'{originalinstructionsenglish}',descreption:'To Display instruction in english'},
            {fieldname:'{drugIntakeAdviceenglish}',descreption:'To Display advice in english'},
            {fieldname:'{instructionsothers}',descreption:'To Display instructions in other language'},
            {fieldname:'{intakeadviceothers}',descreption:'To Display advice in other language'},
            {fieldname : '{dosage}',descreption:'To Display Dosage'},
            {fieldname : '{dosageUnit}',descreption:'To Display Dosage Unit'},
            {fieldname:"{patientyear}",descreption:"To Display Patient Age in Years"},
            {fieldname:'{PrescribedDate}',descreption:'To Display Prescribed Date'}
           ]
        },
        {
          name:'Lab Report Details',
          data:[
            {fieldname:'{patienttitle}',descreption:'To Display patient title'},
            {fieldname:'{patientname}',descreption:'To Display patient name'},
            {fieldname:'{patientgender}',descreption:'To Display patient gender'},
            {fieldname:'{patientstatus}',descreption:'To Display patient status like OP or IP'},
            {fieldname:'{sampleDate}{sampleTime}',descreption:'To Display sample collected date'},
            {fieldname:'{patientno}',descreption:'To Display patient reg no'},
            {fieldname:'{patientage}',descreption:'To Display patient age'},
            {fieldname:'{patientmno}',descreption:'To Display patient mobile no'},
            {fieldname:'{admdocname}',descreption:'To Display doctor name'},
            {fieldname:'{admdocdept}',descreption:'To Display doctor department'},
            {fieldname:'{reportDate}{reportTime}',descreption:'To Display report date'},
            {fieldname:'{titlename}',descreption:'To Display title like group or package name'},
            {fieldname:'{name}',descreption:'To Display test name'},
            {fieldname:'{value}',descreption:'To Display test result'},
            {fieldname:'{unit}',descreption:'To Display unit value based on test'},
            {fieldname:'{normalRange}',descreption:'To Display normal range for particular test'},
            {fieldname:'{billDate}',descreption:'To Display Bill date'},
           ]
        },
        {
          name:'Case Sheet Details',
          data:[
            {fieldname:'{patientno}',descreption:'To Display patient reg no'},
            {fieldname:'{patienttitle}',descreption:'To Display patient title'},
            {fieldname:'{patientname}',descreption:'To Display patient name'},
            {fieldname:'{patientage}',descreption:'To Display patient age'},
            {fieldname:'{patientgender}',descreption:'To Display patient gender'},
            {fieldname:'{patientguardian}',descreption:'To Display patient father name'},
            {fieldname:'{patientDoorno}',descreption:'To Display door no'},
            {fieldname:'{patientregdate}',descreption:'To Display Patient Registration Date'},
            {fieldname:'{patientaddres1}',descreption:'To Display patient address 1'},
            {fieldname:'{patientaddres2}',descreption:'To Display patient address 2'},
            {fieldname:'{patientcity}',descreption:'To Display patient city'},
            {fieldname:'{patientmno}',descreption:'To Display patient mobile no'},
            {fieldname:'{patientstatus}',descreption:'To Display patient status like OP or IP'},
            {fieldname:'{prescriptionDate}',descreption:'To Display prescription created date'},
            {fieldname:'{admdocname}',descreption:'To Display doctor name'},
            {fieldname:'{admdocdept}',descreption:'To Display doctor based department name'},
            {fieldname:'{aadharno}',descreption:'To Display patient AADHAAR no'},
            {fieldname:'{dlnumber}',descreption:'To Display DL number'},
            {fieldname:'{abhanumber}',descreption:'To Display ABHA number'},
            {fieldname:'{occupation}',descreption:'To Display patient occupation'},
            {fieldname:'{currentday}',descreption:'To Display Current Day'},
            {fieldname:'{currentdate}',descreption:'To Display Current Date'},
            {fieldname:'{currenttime}',descreption:'To Display Current Time'}
           ]
        },
        {
          name:'OP bill Details',
          data:[
            {fieldname:'{billno}',descreption:'To Display op bill no'},
            {fieldname:'{billdate}',descreption:'To Display bill date'},
            {fieldname:'{regno}',descreption:'To Display patient reg no'},
            {fieldname:'{regDate}',descreption:'To Display patient reg date'},
            {fieldname:'{doctorname}',descreption:'To Display doctor name'},
            {fieldname:'{patientname}',descreption:'To Display patient name'},
            {fieldname:'{agegender}',descreption:'To Display patient age & gender'},
            {fieldname:'{patientdob}',descreption:'To Display patient dob'},
            {fieldname:'{mobileno}',descreption:'To Display patient mobileno'},
            {fieldname:'{address}',descreption:'To Display patient address'},
            {fieldname:'{aadharno}',descreption:'To Display patient AADHAAR no'},
            {fieldname:'{dlnumber}',descreption:'To Display DL number'},
            {fieldname:'{abhanumber}',descreption:'To Display ABHA number'},
            {fieldname:'{occupation}',descreption:'To Display patient occupation'},
           ]
        },
        {
          name:'Inventory PO Details',
          data:[
            {fieldname:'{supplierName}',descreption:'To Display supplier name'},
            {fieldname:'{supplierPhoneNo}',descreption:'To Display supplier mobileno'},
            {fieldname:'{ponumber}',descreption:'To Display patient PO number'},
            {fieldname:'{supplierCity}',descreption:'To Display supplier city'},
            {fieldname:'{poDate}',descreption:'To Display PO date'},
           ]
        }
      ],

      templatewiseVariableList:[
        {
          name:"Lab Report Placeholders",
          data:[
            {fieldname:"{patienttitle}",descreption:"To Display Patient Title"},
            {fieldname:'{patientname}',descreption:"To Display Patient Name"},
            {fieldname:'{patientgender}' ,descreption:"To Display Patient Gender"},
            {fieldname:'{patientstatus}' ,descreption:"To Display Patient Status"},
            {fieldname:'{sampleDate}{sampleTime}' ,descreption:"To Display Patient Sample Date"},
            {fieldname:'{patientno}' ,descreption:"To Display Patient Number"},
            {fieldname:'{patientBarcode}' ,descreption:"To Display Patient Barcode"},
            {fieldname:'{patientage}' ,descreption:"To Display Patient Age"},
            {fieldname:'{patientmno}' ,descreption:"To Display Patient Mobile Number"},
            {fieldname:'{admdocname}' ,descreption:"To Display Patient Doctor Name"},
            {fieldname:'{admdocdept}' ,descreption:"To Display Patient Doctor Department"},
            {fieldname:'{reportDate}{reportTime}' ,descreption:"To Display Patient Report Date"},
            {fieldname:'{patientregDate}',descreption:"To Display Patient Register Date"},
            {fieldname:'{billDate}' ,descreption:"To Display Patient BillDate"},
            {fieldname:'{billNo}' ,descreption:"To Display Patient BillNo"},
            {fieldname:'{patientreferral}' ,descreption:"To Display Patient Referral"},
            {fieldname:'{currentdate}' ,descreption:"To Display Patient Current Date"},
            {fieldname:'{currenttime}' ,descreption:"To Display Patient Current Time"},
              ]
        },
        {
          name:'IP-Discharge-Summary & IP-Assessment Placeholders',
          data:[
              { fieldname: "{patientname}", descreption: "To Display Full Patient Name" },
              { fieldname: "{patientname2}", descreption: "To Display Full Patient Name (alternative)" },
              { fieldname: "{patientfname}", descreption: "To Display Patient First Name" },
              { fieldname: "{patientlname}", descreption: "To Display Patient Last Name" },
              { fieldname: "{patientmno}", descreption: "To Display Patient Mobile Number" },
              { fieldname: "{patientid}", descreption: "To Display Patient ID Number" },
              { fieldname: "{patientage}", descreption: "To Display Patient Age" },
              { fieldname: "{patientgender}", descreption: "To Display Patient Gender" },
              { fieldname: "{patientnhid}", descreption: "To Display Patient NHID" },
              { fieldname: "{patientaadharno}", descreption: "To Display Patient AADHAAR Number" },
              { fieldname: "{patienttitle}", descreption: "To Display Patient Title" },
              { fieldname: "{patientregdate}", descreption: "To Display Patient Registration Date" },
              { fieldname: "{patientdob}", descreption: "To Display Patient Date of Birth" },
              { fieldname: "{patientemail}", descreption: "To Display Patient Email" },
              { fieldname: "{patientdoorno}", descreption: "To Display Patient Door Number" },
              { fieldname: "{patientaddress}", descreption: "To Display Patient Address" },
              { fieldname: "{patientaddres1}", descreption: "To Display Patient Address Line 1" },
              { fieldname: "{patientaddres2}", descreption: "To Display Patient Address Line 2" },
              { fieldname: "{patientpincode}", descreption: "To Display Patient Pincode" },
              { fieldname: "{patientcity}", descreption: "To Display Patient City" },
              { fieldname: "{docdept}", descreption: "To Display Doctor's Department" },
              { fieldname: "{patientipno}", descreption: "To Display Patient IP Number" },
              { fieldname: "{docname2}", descreption: "To Display Full Doctor Name with Department" },
              { fieldname: "{admdocname}", descreption: "To Display Admission Doctor's Name" },
              { fieldname: "{docname}", descreption: "To Display Doctor's Name" },
              { fieldname: "{doccontno}", descreption: "To Display Doctor's Contact Number" },
              { fieldname: "{admdocdept}", descreption: "To Display Admission Doctor's Department" },
              { fieldname: "{admdoccontno}", descreption: "To Display Admission Doctor's Contact Number" },
              { fieldname: "{admbedno}", descreption: "To Display Admission Bed Number" },
              { fieldname: "{admwardname}", descreption: "To Display Admission Ward Name" },
              { fieldname: "{admdoat}", descreption: "To Display Admission Date and Time" },
              { fieldname: "{disdodt}", descreption: "To Display Discharge Date and Time" },
              { fieldname: "{relationship}", descreption: "To Display Patient's Relationship" },
              { fieldname: "{relativename}", descreption: "To Display Relative's Name" },
              { fieldname: "{relativenumber-1}", descreption: "To Display Relative's Mobile Number" },
              { fieldname: "{relativenumber-2}", descreption: "To Display Relative's Landline Number" },
              { fieldname: "{secondaryphysicianname}", descreption: "To Display Secondary Physician's Name" },
              { fieldname: "{secondaryphysiciandisplayname}", descreption: "To Display Secondary Physician's Display Name" },
              { fieldname: "{secondarydocdepartment}", descreption: "To Display Secondary Physician's Department" },
              { fieldname: "{mlcno}", descreption: "To Display MLC Number" },
              { fieldname: "{receiptno}", descreption: "To Display Receipt Number" },
              { fieldname: "{receiptdate}", descreption: "To Display Receipt Date and Time" },
              { fieldname: "{frroNo}", descreption: "To Display FRRO Number" },
              { fieldname: "{currentdate}", descreption: "To Display Current Date" },
              { fieldname: "{currenttime}", descreption: "To Display Current Time" },
              { fieldname: "{printedby}", descreption: "To Display Printed By Information" },
              { fieldname: "{planneddiscdate}", descreption: "To Display Planned Discharge Date" },
              { fieldname: "{planneddisctime}", descreption: "To Display Planned Discharge Time" },
              { fieldname: "{relation}", descreption: "To Display Patient's Relation (e.g. S/o.)" },
              { fieldname: "{relationname}", descreption: "To Display Patient's Relation Name" },
              { fieldname: "{surgeonName}", descreption: "To Display Chief Surgeon Name" }


          ]
        },
        {
          name:'OP-Assessment Placeholders',
          data:[
              { fieldname: "{patientid}", descreption: "To Display Patient ID" },
              { fieldname: "{patienttitle}", descreption: "To Display Patient Title" },
              { fieldname: "{patientname}", descreption: "To Display Full Patient Name (First and Last)" },
              { fieldname: "{patientguardian}", descreption: "To Display Patient Guardian's Name" },
              { fieldname: "{patientmno}", descreption: "To Display Patient Mobile Number" },
              { fieldname: "{patientage}", descreption: "To Display Patient Age" },
              { fieldname: "{patientgender}", descreption: "To Display Patient Gender" },
              { fieldname: "{patientstatus}", descreption: "To Display Patient Status" },
              { fieldname: "{patientdoorno}", descreption: "To Display Patient Door Number" },
              { fieldname: "{patientaddres1}", descreption: "To Display Patient Address Line 1 (including Door Number)" },
              { fieldname: "{patientaddres2}", descreption: "To Display Patient Address Line 2" },
              { fieldname: "{patientcity}", descreption: "To Display Patient City" },
              { fieldname: "{patientreferral}", descreption: "To Display Patient Referral (if available)" },
              { fieldname: "{visitdatetime}", descreption: "To Display Visit Date and Time (Full Format)" },
              { fieldname: "{visitdate}", descreption: "To Display Visit Date (Date Only)" },
              { fieldname: "{visittime}", descreption: "To Display Visit Time (Time Only)" },
              { fieldname: "{visitdoctorname}", descreption: "To Display Visit Doctor's Name" },
              { fieldname: "{visitdoctordep}", descreption: "To Display Visit Doctor's Department" },
              { fieldname: "{aadharno}", descreption: "To Display Patient AADHAAR Number" },
              { fieldname: "{dlnumber}", descreption: "To Display Patient's Driving License Number" },
              { fieldname: "{abhanumber}", descreption: "To Display Patient NHID (AADHAAR Number)" },
              { fieldname: "{occupation}", descreption: "To Display Patient Occupation" }
                        
          ]
        },
        {
          name:"Case Sheet Placeholders",
          data:[
            {fieldname:"{patientno}",descreption:"To Display Patient Number"},
            {fieldname:"{hospitalTokenNo}",descreption:"To Display Patient Token Number"},
            {fieldname:"{patienttitle}",descreption:"To Display Patient Title"},
            {fieldname:"{patientname}",descreption:"To Display Patient Name"},
            {fieldname:"{patientguardian}",descreption:"To Display Patient Guardian"},
            {fieldname:"{patientmno}",descreption:"To Display Patient MobileNumber"},
            {fieldname:"{patientyear}",descreption:"To Display Patient Age in Years"},
            {fieldname:"{patientage}",descreption:"To Display Patient Age"},
            {fieldname:"{patientgender}",descreption:"To Display Patient Gender"},
            {fieldname:"{patientstatus}",descreption:"To Display Patient Status"},
            {fieldname:"{patientDoorno}",descreption:"To Display PatientDoorNumber"},
            {fieldname:"{patientaddres1}",descreption:"To Display Patient Address1"},
            {fieldname:"{patientaddres2}",descreption:"To Display Patient Address2"},
            {fieldname:"{patientcity}",descreption:"To Display Patient City"},
            {fieldname:"{patientreferral}",descreption:"To Display Patient Refferral"},
            {fieldname:"{prescriptionDate}",descreption:"To Display Patient Prescription Date"},
            {fieldname:"{visitDateTime}",descreption:"To Display Patient Visit Date Time"},
            {fieldname:"{visitDate}",descreption:"To Display Patient Visit Date"},
            {fieldname:"{visitTime}",descreption:"To Display Patient Visit Time"},
            {fieldname:"{admdocname}",descreption:"To Display Patient Doctor Name"},
            {fieldname:"{admdocdept}",descreption:"To Display Patient Doctor Department"},
            {fieldname:"{aadharno}",descreption:"To Display Patient AADHAAR Number"},
            {fieldname:"{dlnumber}",descreption:"To Display Patient Driving License Number"},
            {fieldname:"{abhanumber}",descreption:"To Display Patient ABHA Number"},
            {fieldname:"{occupation}",descreption:"To Display Patient Occupation"},
            {fieldname:'{currentday}',descreption:'To Display Current Day'},
            {fieldname:'{currentdate}',descreption:'To Display Current Date'},
            {fieldname:'{currenttime}',descreption:'To Display Current Time'}

          ]
        },
        {
          name:"IP Bill Placeholders",
          data:[
            {fieldname:"{billNumber}",descreption:"To Display Patient Number"},
                  {fieldname:"{billDatePrint}",descreption:"To Display Bill Date Print"},
                  {fieldname:"{regNumber}",descreption:"To Display Patient Register Number"},
                  {fieldname:"{regDate}",descreption:"To Display Patient Register Date"},
                  {fieldname:"{patientPayerName}",descreption:"To Display Patient Payer Name"},
                  {fieldname:"{admissionNumber}",descreption:"To Display Patient Admission Number"},
                  {fieldname:"{Adm Date}",descreption:"To Display Patient Admission Date"},
                  {fieldname:"{dischargeDate}",descreption:"To Display Patient Discharge Date"},
                  {fieldname:"{physicianName}",descreption:"To Display Patient Physician Name"},
                  {fieldname:"{bedNo}",descreption:"To Display Patient Bed Number"},
                  {fieldname:"{patientName}",descreption:"To Display Patient Name"},
                  {fieldname:"{patientGender}",descreption:"To Display Patient Gender"},
                  {fieldname:"{patientdob}",descreption:"To Display Patient Date Of Birth"},
                  {fieldname:"{mobileno}",descreption:"To Display Patient Mobile Number"},
                  {fieldname:"{address}",descreption:"To Display Patient Address"},
                  {fieldname:"{aadharno}",descreption:"To Display Patient AADHAAR Number"},
                  {fieldname:"{dlnumber}",descreption:"To Display Driving licence"},
                  {fieldname:"{attenderName}",descreption:"To Display Patient Attender Name"},
                  {fieldname:"{abhanumber}",descreption:"To Display Patient ABHA number"},
                  {fieldname:"{wardName}",descreption:"To Display Patient Ward Name"},
                  {fieldname:"{roomNo}",descreption:"To Display Patient Room Number"},
                  {fieldname:"{disBedNo}",descreption:"To Display Patient Bed Number"},
                  {fieldname:"{disWardName}",descreption:"To Display Patient Ward Number"},
                  {fieldname:"{disRoomNo}",descreption:"To Display Patient Room Number"},
                  {fieldname:"{panNo}",descreption:"To Display Patient Pancard Number"},
                  {fieldname:"{occupation}",descreption:"To Display Patient Occupation"},
                  {fieldname:"{frroNo}",descreption:"To Display FRRO Number"},
                  {fieldname:"{claimNo}",descreption:"To Display Patient Claim Number"},
                  {fieldname:"{tpaName}",descreption:"To Display Patient Patient Payer Name"},
                  { fieldname: "{id}", descreption: "To Display ID" },
                  { fieldname: "{serviceName}", descreption: "To Display Service Name" },
                  { fieldname: "{phBillNoDate}", descreption: "To Display Physician Bill Number and Date" },
                  { fieldname: "{physician}", descreption: "To Display Physician's Name" },
                  { fieldname: "{dateTime}", descreption: "To Display Service Date and Time" },
                  { fieldname: "{qty}", descreption: "To Display Quantity" },
                  { fieldname: "{rate}", descreption: "To Display Rate" },
                  { fieldname: "{charges}", descreption: "To Display Charges" },
                  { fieldname: "{discountAmount}", descreption: "To Display Discount Amount" },
                  { fieldname: "{NetAmount}", descreption: "To Display Net Amount" },
                  { fieldname: "{rateTotal}", descreption: "To Display Total Rate" },
                  { fieldname: "{amountTotal}", descreption: "To Display Total Amount" },
                  { fieldname: "{discountAmountTotal}", descreption: "To Display Total Discount Amount" },
                  { fieldname: "{netAmountTotal}", descreption: "To Display Total Net Amount" },
                  { fieldname: "{srvReqNo}", descreption: "To Display Service Request Number" }
                
          ]
        },
        {
          name:'IP Bill Payment Detail Placeholders',
          data : [
            { fieldname: "{discountLabel}", descreption: "To Display Patient PrinterDiscountLabel" },
            { fieldname: "{billAmount}", descreption: "To Display Patient BillAmount" },
            { fieldname: "{finalDiscountAmount}", descreption: "To Display Patient FinalDiscountAmount" },
            { fieldname: "{netAmount}", descreption: "To Display Patient NetAmount" },
            { fieldname: "{netAmountinwords}", descreption: "To Display Patient NetAmountInWords" },
            { fieldname: "{paymentData}", descreption: "To Display Patient PaymentData" },
            { fieldname: "{advance}", descreption: "To Display Patient Advance" },
            { fieldname: "{pendingAmount}", descreption: "To Display Patient PendingAmount" },
            { fieldname: "{multiplePaymentAmountValue}", descreption: "To Display Patient MultiplePaymentAmountValue" },
            { fieldname: "{selfCreditAmount}", descreption: "To Display Patient SelfCreditAmount" },
            { fieldname: "{totalPaidWithCredit}", descreption: "To Display Paid Amount Including Self Credit" },

            { fieldname: "{refundPayment}", descreption: "To Display Patient RefundPayment" },
            { fieldname: "{insuranceAmount}", descreption: "To Display Patient InsuranceAmount" },
            { fieldname: "{insuranceName}", descreption: "To Display Patient InsuranceName" },
            { fieldname: "{billStatus}", descreption: "To Display Patient BillStatus" },
            { fieldname: "{preparedBy}", descreption: "To Display Patient PreparedBy" },
            { fieldname: "{currency}", descreption: "To Display Patient Currency" },
            { fieldname: "{currentdate}", descreption: "To Display Patient CurrentDate" },
            { fieldname: "{currenttime}", descreption: "To Display Patient currentTime" }
          ]
          
        },
        {
          name:"OPD Slip Placeholders",
          data:[
            {fieldname:"{patientname}",descreption:"To Display Patient Name"},
              {fieldname:"{patientname2}",descreption:"To Display Patient"},
              {fieldname:"{patientfname}",descreption:"To Display Patient FirstName"},
              {fieldname:"{patientmno}",descreption:"To Display Patient MobileNumber"},
              {fieldname:"{patientid}",descreption:"To Display Patient Registration Number"},
              {fieldname:"{docname2}",descreption:"To Display Patient DoctorName"},
              {fieldname:"{mlcno}",descreption:"To Display Patient ///////////////////////////////"},
              {fieldname:"{patientage}",descreption:"To Display Patient Age"},
              {fieldname:"{patientgender}",descreption:"To Display Patient Gender"},
              {fieldname:"{patientnhid}",descreption:"To Display Patient ////////////////////////////////"},
              {fieldname:"{patientaadharno}",descreption:"To Display Patient AADHAAR Number"},
              {fieldname:"{patienttitle}",descreption:"To Display Patient Title"},
              {fieldname:"{patientregdate}",descreption:"To Display Patient Registration Date"},
              {fieldname:"{patientregdate-DD/MM/YYYY}",descreption:"To Display Patient DateInDD/MM/YYYY"},
              {fieldname:"{patientdob}",descreption:"To Display Patient DateOfBirth"},
              {fieldname:"{patientemail}",descreption:"To Display Patient Email"},
              {fieldname:"{patientdoorno}",descreption:"To Display Patient DoorNumber"},
              {fieldname:"{patientaddress}",descreption:"To Display Patient Address"},
              {fieldname:"{patientaddres2}",descreption:"To Display Patient Address2"},
              {fieldname:"{patientcity}",descreption:"To Display Patient City"},
              {fieldname:"{patientpincode}",descreption:"To Display Patient Pincode"},
              {fieldname:"{frroNo}",descreption:"To Display Patient FRRO Number"},
              {fieldname:"{aadharno}",descreption:"To Display Patient AADHAAR Number"},
              {fieldname:"{dlnumber}",descreption:"To Display Patient DrivingLicenseNumber"},
              {fieldname:"{abhanumber}",descreption:"To Display Patient ABHA Number"},
              {fieldname:"{occupation}",descreption:"To Display Patient Occupation"},
              {fieldname:"{admdocname}",descreption:"To Display Appointment Doctor Name"},
              {fieldname:"{docname}",descreption:"To Display Patient Doctor Name"},
              {fieldname:"{admdocdept}",descreption:"To Display Appointment Doctor Department"},
              {fieldname:"{docdept}",descreption:"To Display Patient Appointment Doctor Department"},
              {fieldname:"{doccontno}",descreption:"To Display Patient Doctor Contact Number"},
              {fieldname:"{appointmentno}",descreption:"To Display Appointment Number"},
              {fieldname:"{admdoat}",descreption:"To Display Patient"},
              {fieldname:"{admdoat-DD/MM/YYYY}",descreption:"To Display Patient"},
              {fieldname:"{validupto}",descreption:"To Display Valid Upto"},
              {fieldname:"{validupto-DD/MM/YYYY}",descreption:"To Display Valid Upto - DD/MM/YYYY"},
              {fieldname:"{vitalheight}",descreption:"To Display Vital Height"},
              {fieldname:"{vitalpulse}",descreption:"To Display Vital Pulse"},
              {fieldname:"{vitalbp}",descreption:"To Display Vital BP"},
              {fieldname:"{vitalweight}",descreption:"To Display Vital Weight"},
              {fieldname:"{vitaltemparature}",descreption:"To Display Vital Temparature"},
              {fieldname:"{vitalspo}",descreption:"To Display Vital SPO"},
              {fieldname:"{vitalbmi}",descreption:"To Display Vital BMI"},
              {fieldname:"{vitalresp}",descreption:"To Display Vital Resprate"},
              {fieldname:"{visitdate}",descreption:"To Display Visit Date"},
              {fieldname:"{visitdate-DD/MM/YYYY}",descreption:"To Display Visit Date DD/MM/YYYY"},
              {fieldname:"{visittime}",descreption:"To Display Patient Visit Time"},
              {fieldname:"{patientguardian}",descreption:"To Display Patient Guardian"},
              {fieldname:"{formattedVisitdate}",descreption:"To Display Patient Visit Date"},
          ]
        },
        {
          name:"Radiology Placeholders",
          data:[
            {fieldname:"{patientname}",descreption:"To Display Patient Name"},
            {fieldname:"{patientguardian}",descreption:"To Display Patient Guardian"},
            {fieldname:"{patientage}",descreption:"To Display Patient Age"},
            {fieldname:"{patientid}",descreption:"To Display Patient Id"},
            {fieldname:"{mobile}",descreption:"To Display Patient Mobile Number"},
            {fieldname:"{patienttype}",descreption:"To Display Patient Type"},
            {fieldname:"{doctorname}",descreption:"To Display Doctor Name"},
            {fieldname:"{admissionid}",descreption:"To Display AdmissionId"},
            {fieldname:"{billid}",descreption:"To Display BillId"},
            {fieldname:"{billdate}",descreption:"To Display BillDate"},
            {fieldname:"{workorderno}",descreption:"To Display Workorder No"},
            {fieldname:"{workorderdate}",descreption:"To Display Workorder Date"},
            {fieldname:"{docname}",descreption:"To Display Doctor Name"},
            {fieldname:"{patientgender}",descreption:"To Display Patient Gender"},
            {fieldname:"{patientregdate}",descreption:"To Display Patient Registration Date"},
          ]
        },
        {
          name:"OP Bill Placeholders",
          data:[
            {fieldname:"{billno}",descreption:"To Display Patient Bill Number"},
            {fieldname:"{billdate}",descreption:"To Display Bill Date"},
            {fieldname:"{regno}",descreption:"To Display Patient Registration Number"},
            {fieldname:"{frroNo}",descreption:"To Display FRRO Number"},
            {fieldname:"{regDate}",descreption:"To Display Patient Registration Date"},
            {fieldname:"{doctorname}",descreption:"To Display DoctorName"},
            {fieldname:"{patientname}",descreption:"To Display Patient Name"},
            {fieldname:"{agegender}",descreption:"To Display Patient Age & Gender"},
            {fieldname:"{patientguardian}",descreption:"To Display Patient Guardian"}, 
            {fieldname:"{patienttitle}",descreption:"To Display Patient Title"},
            {fieldname:"{patientdob}",descreption:"To Display Patient Date Of Birth"},
            {fieldname:"{mobileno}",descreption:"To Display Patient Mobile Number"},
            {fieldname:"{address}",descreption:"To Display Patient Address"},
            {fieldname:"{aadharno}",descreption:"To Display Patient AADHAAR Number"},
            {fieldname:"{dlnumber}",descreption:"To Display Patient Driving License Number"},
            {fieldname:"{abhanumber}",descreption:"To Display Patient ABHA number"},
            {fieldname:"{occupation}",descreption:"To Display Patient Occupation"},
          ]
        },
        {
          name:"OP Bill Payment Detail Placeholders",
          data:[
            {fieldname:"{totalValue}",descreption:"To Display Total Value"},
            {fieldname:"{finalDiscount}",descreption:"To Display Final Discount"},
            {fieldname:"{netAmount}",descreption:"To Display Net Amount"},
            {fieldname:"{netAmountinword}",descreption:"To Display Amount in words"},
            {fieldname:"{paymentData}",descreption:"To Display PaymentData"},
            {fieldname:"{balanceAmountprint}",descreption:"To Display Balance Amount print"},
            {fieldname:"{billStatus}",descreption:"To Display Bill Status"},
            {fieldname:"{preparedBy}",descreption:"To Display User name"},
            {fieldname:"{doneBy}",descreption:"To Display Done By"},
            {fieldname:"{currency}",descreption:"To Display Currency"},
            {fieldname:"{currentdate}",descreption:"To Display Currentdate"},
            {fieldname:"{currenttime}",descreption:"To Display Currenttime"},
          ]
        },
        {
          name:"Prescription Placeholders",
          data:[
            {fieldname:"{patientno}",descreption:"To Display Patient Registration Number"},
            {fieldname:"{hospitalTokenNo}",descreption:"To Display Token Number"},
            {fieldname:"{regDate}",descreption:"To Display Patient Registration Date"},
            {fieldname:"{patienttitle}",descreption:"To Display Patient Title"},
            {fieldname:"{patientname}",descreption:"To Display Patient Name"},
            {fieldname:"{patientguardian}",descreption:"To Display Patient Guardian Name"},
            {fieldname:"{patientmno}",descreption:"To Display Patient Mobile Number"},
            {fieldname:"{patientage}",descreption:"To Display Patient Age"},
            {fieldname:"{patientgender}",descreption:"To Display Patient Gender"},
            {fieldname:"{patientstatus}",descreption:"To Display Patient Status"},
            {fieldname:"{patientDoorno}",descreption:"To Display Patient Door Number"},
            {fieldname:"{patientaddres1}",descreption:"To Display Patient Address 1"},
            {fieldname:"{patientaddres2}",descreption:"To Display Patient Address 2"},
            {fieldname:"{patientcity}",descreption:"To Display Patient City"},
            {fieldname:"{prescriptionDate}",descreption:"To Display Prescription Date"},
            {fieldname:"{admdocname}",descreption:"To Display Doctor Name"},
            {fieldname:"{admdocdept}",descreption:"To Display Doctor Department Name"},
          ]
        },
        {
          name:"Sales Bill Placeholders",
          data:[
            {fieldname:"{patientid}",descreption:"To Display Patient Id"},
            {fieldname:"{regDate}",descreption:"To Display Patient Registration Date"},
            {fieldname:"{patienttitle}",descreption:"To Display Patient Title"},
            {fieldname:"{patientname}",descreption:"To Display Patient Name"},
            {fieldname:"{patientguardian}",descreption:"To Display Patient Guardian"},
            {fieldname:"{patientage}",descreption:"To Display Patient Age"},
            {fieldname:"{patientgender}",descreption:"To Display Patient Gender"},
            {fieldname:"{patientmno}",descreption:"To Display Patient Mobile Number"},
            {fieldname:"{patientstatus}",descreption:"To Display Patient Status"},
            {fieldname:"{patientaddres1}",descreption:"To Display Patient Address1"},
            {fieldname:"{patientcity}",descreption:"To Display Patient City"},
            {fieldname:"{salesbillno}",descreption:"To Display Sales Bill Number"},
            {fieldname:"{salesbillDate}",descreption:"To Display Sales Bill Date"},
            {fieldname:"{admdocname}",descreption:"To Display Admission Doctor Name"},
            {fieldname:"{referral}",descreption:"To Display Patient Referral"},
            {fieldname:"{admdocdept}",descreption:"To Display Admission Doctor Department"},
            {fieldname:"{patientipno}",descreption:"To Display Patient Ip Number"},
            {fieldname:"{admdoat}",descreption:"To Display Patient Admission Date"},
            {fieldname:"{ipdischargeDate}",descreption:"To Display Patient Discharge Date"},
            {fieldname:"{admbedno}",descreption:"To Display Patient Bed Number"},
            {fieldname:"{phNettotal}",descreption:"To Display phNetTotal"},
            {fieldname:"{phDiscountamount}",descreption:"To Display phDiscount amount"},
            {fieldname:"{totallineitemsdiscount}",descreption:"To Display Total line Items Discount"},
            {fieldname:"{phBillTotal}",descreption:"To Display phBill Total"},
            {fieldname:"{phtaxTotal}",descreption:"To Display phTax Total"},
            {fieldname:"{phDiscountamount}",descreption:"To Display phDiscount Amount"},
            {fieldname:"{phRoundofftpe}",descreption:"To Display phRoundoffTpe"},
            {fieldname:"{phRoundoff}",descreption:"To Display phRoundoff"},
            {fieldname:"{paymentType}",descreption:"To Display PaymentType"},
            {fieldname:"{paidamountinwords}",descreption:"To Display Paid Amount In Words"},
            {fieldname:"{currency}",descreption:"To Display Currrency"},
            {fieldname:"{currencyForDiscount}",descreption:"To Display Patient Currency For Discount"},
            {fieldname:"{currentdate}",descreption:"To Display Current Date"},
            {fieldname:"{currenttime}",descreption:"To Display CurrentTime"},
          ]
        },
        {
          name:"Patient Detail Placeholders",
          data:[
            {fieldname:"{patientid}",descreption:"To Display Patient Id"},
            {fieldname:"{patientregdate}",descreption:"To Display Patient Registration Date"},
            {fieldname:"{patientname} ",descreption:"To Display Patient Name"},
            {fieldname:"{patientage}",descreption:"To Display Patient Age"},
            {fieldname:"{patientgender}",descreption:"To Display Patient Gender"},
            {fieldname:"{bloodGroup}",descreption:"To Display Patient Blood Group"},
            {fieldname:"{mobile}",descreption:"To Display Patient Mobile"},
            {fieldname:"{alternateMobile}",descreption:"To Display Patient Alternate Mobile"},
            {fieldname:"{email}",descreption:"To Display Patient Email"},
            {fieldname:"{adharNum}",descreption:"To Display Patient AADHAAR Number"},
            {fieldname:"{patientaddress}",descreption:"To Display Patient Address"},
            {fieldname:"{patientguardian}",descreption:"To Display Patient Guardian Name"},
            {fieldname:"{patientType}",descreption:"To Display Patient Type"},
          ]
        },
        {
          name:"Consent Certificate Placeholders",
          data:[
            {fieldname:"{patientname}",descreption:"To Display Patient Name"},
            {fieldname:"{patientguardian}",descreption:"To Display Patient Guardian"},
            {fieldname:"{patientage}",descreption:"To Display Patient Age"},
            {fieldname:"{patientid}",descreption:"To Display Patient Id"},
            {fieldname:"{mobile}",descreption:"To Display Patient Mobile"},
            {fieldname:"{patienttype}",descreption:"To Display Patient Type"},
            {fieldname:"{patientaddress}",descreption:"To Display Patient Address"},
            {fieldname:"{patientgender}",descreption:"To Display Patient Gender"},
            {fieldname:"{patientregdate}",descreption:"To Display Patient Registration Date"},
            {fieldname:"{admdocname}",descreption:"To Display Patient's Doctor Name"},
            {fieldname:"{admdocdept}",descreption:"To Display Patient's Doctor Department"},
            {fieldname:"{admissionid}",descreption:"To Display Patient Admission Number"},
            {fieldname:"{admdoat}",descreption:"To Display Patient  Admission Date"},
            {fieldname:"{disdodt}",descreption:"To Display Patient Discharged date"},
            {fieldname:"{singedBy}",descreption:"To Display Patient SingedBy "},
            {fieldname:"{signedDate}",descreption:"To Display Patient Signed Date"},
            {fieldname:"{signature}",descreption:"To Display Patient Signature"},
            {fieldname:"{signedRelation}",descreption:"To Display Patient Signed Relation"},
            {fieldname:"{nurseName}",descreption:"To Display Patient Nurse Name"},
          ]
        },
        {
          name:"Nurse Handover Placeholders",
          data:[
            {fieldname:"{wardname}",descreption:"To Display Patient Ward Name"},
              {fieldname:"{visitId} ",descreption:"To Display Patient Visited"},
              {fieldname:"{bedId}",descreption:"To Display Patient Bed Id"},
              {fieldname:"{wardid}",descreption:"To Display Patient Ward Id"},
              {fieldname:"{visitdoctordeptid}",descreption:"To Display Doctor Department Id"},
              {fieldname:"{visitdoctorid}",descreption:"To Display Visit Doctor Id"},
              {fieldname:"{admissiondate}",descreption:"To Display Patient Admission Date"},
              {fieldname:"{admissiontime}",descreption:"To Display Patient Admission Time"},
              {fieldname:"{admissionnumber}",descreption:"To Display Patient Admission Number"},
              {fieldname:"{admissionstatus}",descreption:"To Display Patient Admission Status"},
              {fieldname:"{bedno}",descreption:"To Display Patient Bed Number"},
              {fieldname:"{doctor}",descreption:"To Display Patient's Doctor Display Name"},
              {fieldname:"{patientname}",descreption:"To Display Patient Name"},
              {fieldname:"{patientgender}",descreption:"To Display Patient Gender"},
              {fieldname:"{patientage}",descreption:"To Display Patient Age"},
              {fieldname:"{patientmno}",descreption:"To Display Patient Mobile Number"},
              {fieldname:"{patientregDate}",descreption:"To Display Patient Registration Date"},
              {fieldname:"{patientregNo}",descreption:"To Display Patient Registration Number"},
              {fieldname:"{currentDate}",descreption:"To Display Patient Current Date"},
              {fieldname:"{departmentName}",descreption:"To Display Patient Department Name"},
              {fieldname:"{ward}",descreption:"To Display Patient Ward"},
              {fieldname:"{handoverdate}",descreption:"To Display Handover Date"},
              {fieldname:"{handovertime}",descreption:"To Display HandOver Time"},
              {fieldname:"{currentnursename}",descreption:"To Display Current Nurse Name"},
              {fieldname:"{receivernursename}",descreption:"To Display Receiver Nurse Name"},
              {fieldname:"{currentnurseid}",descreption:"To Display Current Nurse Id"},
              {fieldname:"{receivernurseid}",descreption:"To Display Receiver Nurse Id"},
          ]
        },
       
      ]
}
